import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Container, Row } from "reactstrap";
import UserView from "./components/UserView";
import PageHeader from "../../../shared/components/PageHeader";
import { getUser } from "../actions/user.actions";

const ViewUser = (props) => {
    const { dispatch, user, currentDomain } = props;

    function fetchUser() {
        dispatch(getUser({ searchWord: props.match.params.id, pageNum: 1, pageSize: 10 }));
    }

    useEffect(() => {
        if (props.match.params.id) {
            dispatch(getUser({ searchWord: props.match.params.id, pageNum: 1, pageSize: 10 }));
        }
    }, [dispatch, props.match.params.id]);

    return (
        <Container>
            <PageHeader header="View User" subheader="View user's information" />
            <Row>
                <UserView userId={props.match.params.id} user={user} fetchData={fetchUser} userDomain={currentDomain} />
            </Row>
        </Container>
    );
};

export default connect((state) => ({
    user: state.viewuser,
    currentDomain: state.currentUser,
}))(ViewUser);
